export default "__VITE_ASSET___lyqtelT__"